const GET_FILES = `
  query getFiles($where: JSON, $limit: Int, $offset: Int, $sort: [GetFilesSortItem]){
    files: getFiles(where: $where, limit: $limit, offset: $offset, sort: $sort){
      mimetype,
      id,
      filename,
      name,
      url,
      type,
      updated,
      data,
      storeKey
    },
    total: countFiles(where: $where)
  }
`;

const GET_COUNT_ALL_FILES = `
  query {
    all: countFiles(where: {
      type: {
        _in: ["image", "text", "video"]
      }
    })
    image: countFiles(where: {
      type: "image"
    })
    text: countFiles(where: {
      type: "text"
    })
    video: countFiles(where: {
      type: "video"
    })
  }
`;

const GET_FILES_WHERE = `
  query getFiles($where: JSON){
    getFiles(where: $where){
      mimetype,
      id,
      name,
      url
    }
  }
`;

const GET_FILE_BY_ID = `
  query getFile($id: String!) {
    file: getFile(id: $id) {
      id
      location
      mimetype
      url
      data,
      name,
      storeKey,
      filename
      type
      updated
    }
  }
`;

const GET_FILE_STORES = `
  query getFileStores($visibleInAdmin: Boolean) {
    getFileStores(visibleInAdmin: $visibleInAdmin) {
        name
        key
        isDefault
        displayInAdmin
    }
  }
`;

export { GET_FILES, GET_FILES_WHERE, GET_FILE_BY_ID, GET_COUNT_ALL_FILES, GET_FILE_STORES };
